import generateBasicEntityActions from "./generateBasicEntityActions";
import * as schemas from "../schemas";

const walletPositionActions = {
  fetchAll: (clientId) => ({
    API_CALL: {
      httpMethod: "GET",
      endpoint: `/wallet_position/${clientId}`,
      schema: { walletPositions: [schemas.walletPosition] },
    },
  }),

  fetch: (id) => ({
    API_CALL: {
      httpMethod: "GET",
      endpoint: `/clients/${clientId}/wallet_position/${id}`,
      schema: { walletPosition: schemas.walletPosition },
    },
  }),
};

export default walletPositionActions;
